import * as api from '@/api'

const user = {
  namespaced: true,
  state: {
    shopId: null,
    seatNo: null,
    hasBirthdayEvent: false,
    childrenCount: 0, // 子端末がいくつあるか
    customerId: 0,
    dishCount: 0,
    id: 0,
    seatStatus: -1,
    selfcheckEnabled: 0, // セルフチェック可能店舗かどうか
    isPayingUser: 0, // 0:会計中ユーザーではない, 1:会計中ユーザー
    cashRegisterType: 0, // 0: TEC製レジ 1: NECレジ
    orderRestriction: 0,
    sex: 0,
    checkedInAt: '',
    shopName: '',
    shopLastOrderTime: null,
    // eslint-disable-next-line no-irregular-whitespace
    isChildTerminal: 0, // 子端末かどうか　0=子端末ではない, 1=子端末
    bikkuraponInstalled: null, // ビッくらポンが店舗に設置されているか 0=未設置 1=設置
    gameEnabled: 0, // 運用状態 0=停止中, 1=運用中
    bikkurapon: {
      gameEnabled: 0, // 運用状態 0=停止中, 1=運用中
      availablePlayCount: 0, // ビッくらポン合計抽選可能回数
      playedCount: 0, // 抽選実施回数 抽選を実施した回数
      winningCount: 0, // 当選回数
    },
    sideMenuBikkurapon: {
      gameEnabled: 0, // 運用状態 0=停止中, 1=運用中
      lotteryAmount: 0, // 実施金額 スマホでビッくらポンを実施する金額
      sideMenuAmount: 0, // サイドメニュー合計金額 サイドメニューの送達済み商品の合計金額。
      playedCount: 0, // 抽選実施回数 抽選を実施した回数
      winningCount: 0, // 当選回数
    },
    winRateChangeEnabled: 0, // ビッくらポン当選確率変更 0=無効,1=有効
    priceDisplayEnabled: 0, // 価格表示設定 0=非表示,1=表示
    bikkuraponIconDisplayEnabled: 0, // ビッくらポンアイコン表示設定 0=非表示,1=表示

    isFetching: false,
    error: null,
  },
  getters: {
    getShopId: (state) => {
      return state.shopId
    },
    getSeatNo: (state) => {
      return state.seatNo
    },
    getHasBirthdayEvent: (state) => {
      return state.hasBirthdayEvent
    },
    getChildrenCount: (state) => {
      return state.childrenCount
    },
    getCustomerId: (state) => {
      return state.customerId
    },
    getDishCount: (state) => {
      return state.dishCount
    },
    getId: (state) => {
      return state.id
    },
    getSeatStatus: (state) => {
      return state.seatStatus
    },
    getIsCallingSelfcheck: (state) => {
      return state.seatStatus === 4
    },
    getIsDoingSelfcheck: (state) => {
      return state.seatStatus === 5
    },
    getIsFinishedSelfcheck: (state) => {
      return state.seatStatus === 6
    },
    getIsSelfcheckEnabled: (state) => {
      return state.selfcheckEnabled === 1
    },
    getIsPayingUser: (state) => {
      return state.isPayingUser === 1
    },
    getCashRegisterType: (state) => {
      return state.cashRegisterType
    },
    getOrderRestriction: (state) => {
      return state.orderRestriction
    },
    getSex: (state) => {
      return state.sex
    },
    getCheckedInAt: (state) => {
      return state.checkedInAt
    },
    getShopName: (state) => {
      return state.shopName
    },
    getShopLastOrderTime: (state) => {
      return state.shopLastOrderTime
    },
    getIsChildTerminal: (state) => {
      return state.isChildTerminal
    },
    getBikkuraponInstalled: (state) => {
      return state.bikkuraponInstalled
    },
    getGameEnabled: (state) => {
      return state.gameEnabled
    },
    getBikkuraponEnabled: (state) => {
      return state.bikkurapon.gameEnabled
    },
    getBikkuraponAvailablePlayCount: (state) => {
      return state.bikkurapon.availablePlayCount
    },
    getBikkuraponPlayedCount: (state) => {
      return state.bikkurapon.playedCount
    },
    getBikkuraponWinningCount: (state) => {
      return state.bikkurapon.winningCount
    },
    getSideMenuBikkuraponEnabled: (state) => {
      return state.sideMenuBikkurapon.gameEnabled
    },
    getSideMenuBikkuraponLotteryAmount: (state) => {
      return state.sideMenuBikkurapon.lotteryAmount
    },
    getSideMenuBikkuraponSideMenuAmount: (state) => {
      return state.sideMenuBikkurapon.sideMenuAmount
    },
    getSideMenuBikkuraponPlayedCount: (state) => {
      return state.sideMenuBikkurapon.playedCount
    },
    getSideMenuBikkuraponWinningCount: (state) => {
      return state.sideMenuBikkurapon.winningCount
    },
    getWinRateChangeEnabled: (state) => {
      return state.winRateChangeEnabled
    },
    getPriceDisplayEnabled: (state) => {
      return state.priceDisplayEnabled
    },
    getBikkuraponIconDisplayEnabled: (state) => {
      return state.bikkuraponIconDisplayEnabled
    },
    getIsBikkuraponIconDisplay: (state) => {
      return (
        state.bikkuraponIconDisplayEnabled === 1 &&
        state.bikkuraponInstalled === 1 &&
        state.sideMenuBikkurapon.gameEnabled === 1 &&
        state.gameEnabled === 1
      )
    },
    getValidSeatNo(state) {
      // 座席番号が未定義の場合は,事前注文用の席番号0を指定
      return state.seatNo || 0
    },
    getIsPreOrder: (state, getters) => {
      return getters.getValidSeatNo === 0
    },
    getError: (state) => {
      return state.error
    },
  },
  actions: {
    fetchSeat: async ({ commit }, cancelToken) => {
      try {
        commit('fetchSeatStart', data)
        const { data } = await api.fetchSeat(cancelToken)
        commit('fetchSeatDone', data)
      } catch (error) {
        commit('fetchSeatFailed', error)
      }
    },
    'seat/resetAll': {
      root: true,
      handler({ commit }) {
        commit('resetAll')
      },
    },
    setSeat: ({ commit }, payload) => {
      commit('setSeat', payload)
    },
    setShopId: ({ commit }, payload) => {
      commit('setShopId', payload)
    },
    setSeatNo: ({ commit }, payload) => {
      commit('setSeatNo', payload)
    },
    setHasBirthdayEvent: ({ commit }, payload) => {
      commit('setHasBirthdayEvent', payload)
    },
    setChildrenCount: ({ commit }, payload) => {
      commit('setChildrenCount', payload)
    },
    setCustomerId: ({ commit }, payload) => {
      commit('setCustomerId', payload)
    },
    setDishCount: ({ commit }, payload) => {
      commit('setDishCount', payload)
    },
    setId: ({ commit }, payload) => {
      commit('setId', payload)
    },
    setSeatStatus: ({ commit }, payload) => {
      commit('setSeatStatus', payload)
    },
    isPayingUser: ({ commit }, payload) => {
      commit('isPayingUser', payload)
    },
    setCashRegisterType: ({ commit }, payload) => {
      commit('setCashRegisterType', payload)
    },
    setOrderRestriction: ({ commit }, payload) => {
      commit('setOrderRestriction', payload)
    },
    setSex: ({ commit }, payload) => {
      commit('setSex', payload)
    },
    setCheckedInAt: ({ commit }, payload) => {
      commit('setCheckedInAt', payload)
    },
    setShopName: ({ commit }, payload) => {
      commit('setShopName', payload)
    },
    setShopLastOrderTime: ({ commit }, payload) => {
      commit('setShopLastOrderTime', payload)
    },
    setBikkuraponInstalled: ({ commit }, payload) => {
      commit('setBikkuraponInstalled', payload)
    },
    setGameEnabled: ({ commit }, payload) => {
      commit('setGameEnabled', payload)
    },
    setBikkuraponEnabled: ({ commit }, payload) => {
      commit('setBikkuraponEnabled', payload)
    },
    setBikkuraponAvailablePlayCount: ({ commit }, payload) => {
      commit('setBikkuraponAvailablePlayCount', payload)
    },
    setBikkuraponPlayedCount: ({ commit }, payload) => {
      commit('setBikkuraponPlayedCount', payload)
    },
    setBikkuraponWinningCount: ({ commit }, payload) => {
      commit('setBikkuraponWinningCount', payload)
    },
    setSideMenuBikkuraponEnabled: ({ commit }, payload) => {
      commit('setSideMenuBikkuraponEnabled', payload)
    },
    setSideMenuBikkuraponLotteryAmount: ({ commit }, payload) => {
      commit('setSideMenuBikkuraponLotteryAmount', payload)
    },
    setSideMenuBikkuraponSideMenuAmount: ({ commit }, payload) => {
      commit('setSideMenuBikkuraponSideMenuAmount', payload)
    },
    setSideMenuBikkuraponPlayedCount: ({ commit }, payload) => {
      commit('setSideMenuBikkuraponPlayedCount', payload)
    },
    setSideMenuBikkuraponWinningCount: ({ commit }, payload) => {
      commit('setSideMenuBikkuraponWinningCount', payload)
    },
    setPriceDisplayEnabled: ({ commit }, payload) => {
      commit('setPriceDisplayEnabled', payload)
    },
    setBikkuraponIconDisplayEnabled: ({ commit }, payload) => {
      commit('setBikkuraponIconDisplayEnabled', payload)
    },
  },
  mutations: {
    fetchSeatStart(state) {
      state.error = null
      state.isFetching = true
    },
    fetchSeatDone(state, payload) {
      state.shopId = payload.shopId
      state.seatNo = payload.seatNo
      state.hasBirthdayEvent = payload.birthdayEvent
      state.childrenCount = payload.childrenCount
      state.customerId = payload.customerId
      state.dishCount = payload.dishCount
      state.gameEnabled = payload.gameEnabled
      state.id = payload.id
      state.seatStatus = payload.seatStatus
      state.isPayingUser = payload.isPayingUser
      state.selfcheckEnabled = payload.selfcheckEnabled
      state.cashRegisterType = payload.cashRegisterType
      state.orderRestriction = payload.orderRestriction
      state.sex = payload.sex
      state.checkedInAt = payload.checkedInAt
      state.isChildTerminal = payload.isChildTerminal
      state.bikkuraponInstalled = payload.bikkuraponInstalled
      state.gameEnabled = payload.gameEnabled
      state.bikkurapon = payload.bikkurapon
      state.sideMenuBikkurapon = payload.sideMenuBikkurapon
      state.winRateChangeEnabled = payload.winRateChangeEnabled
      state.priceDisplayEnabled = payload.priceDisplayEnabled
      state.bikkuraponIconDisplayEnabled = payload.bikkuraponIconDisplayEnabled
      state.isFetching = false
    },
    fetchSeatFailed(state, error) {
      state.error = error
      state.isFetching = false
    },
    resetAll(state) {
      state.shopId = null
      state.seatNo = null
      state.hasBirthdayEvent = false
      state.childrenCount = 0
      state.customerId = 0
      state.dishCount = 0
      state.gameEnabled = 0
      state.id = 0
      state.seatStatus = 0
      state.selfcheckEnabled = 0
      state.isPayingUser = 0
      state.cashRegisterType = 0
      state.orderRestriction = 0
      state.sex = 0
      state.checkedInAt = ''
      state.shopName = ''
      state.shopLastOrderTime = null
    },
    setSeat(state, payload) {
      state.shopId = payload.shopId
      state.seatNo = payload.seatNo
      state.hasBirthdayEvent = payload.birthdayEvent
      state.childrenCount = payload.childrenCount
      state.customerId = payload.customerId
      state.dishCount = payload.dishCount
      state.gameEnabled = payload.gameEnabled
      state.id = payload.id
      state.seatStatus = payload.seatStatus
      state.isPayingUser = payload.isPayingUser
      state.selfcheckEnabled = payload.selfcheckEnabled
      state.cashRegisterType = payload.cashRegisterType
      state.orderRestriction = payload.orderRestriction
      state.sex = payload.sex
      state.checkedInAt = payload.checkedInAt
      state.isChildTerminal = payload.isChildTerminal
      state.bikkuraponInstalled = payload.bikkuraponInstalled
      state.gameEnabled = payload.gameEnabled
      state.bikkurapon = payload.bikkurapon
      state.sideMenuBikkurapon = payload.sideMenuBikkurapon
      state.winRateChangeEnabled = payload.winRateChangeEnabled
      state.priceDisplayEnabled = payload.priceDisplayEnabled
      state.bikkuraponIconDisplayEnabled = payload.bikkuraponIconDisplayEnabled
    },
    setShopId(state, payload) {
      state.shopId = payload
    },
    setSeatNo(state, payload) {
      state.seatNo = payload
    },
    setHasBirthdayEvent(state, payload) {
      state.hasBirthdayEvent = payload
    },
    setChildrenCount(state, payload) {
      state.childrenCount = payload
    },
    setCustomerId(state, payload) {
      state.customerId = payload
    },
    setDishCount(state, payload) {
      state.dishCount = payload
    },
    setId(state, payload) {
      state.id = payload
    },
    setSeatStatus(state, payload) {
      state.seatStatus = payload
    },
    setIsPayingUser(state, payload) {
      state.isPayingUser = payload
    },
    setCashRegisterType(state, payload) {
      state.cashRegisterType = payload
    },
    setOrderRestriction(state, payload) {
      state.orderRestriction = payload
    },
    setSex(state, payload) {
      state.sex = payload
    },
    setCheckedInAt(state, yyyymmddhhmmss) {
      state.checkedInAt = yyyymmddhhmmss
    },
    setShopName(state, payload) {
      state.shopName = payload
    },
    setShopLastOrderTime(state, shopLastOrderTime) {
      state.shopLastOrderTime = shopLastOrderTime
    },
    setBikkuraponInstalled(state, payload) {
      state.bikkuraponInstalled = payload
    },
    setGameEnabled(state, payload) {
      state.gameEnabled = payload
    },
    setBikkuraponEnabled(state, payload) {
      state.bikkurapon.gameEnabled = payload
    },
    setBikkuraponAvailablePlayCount(state, payload) {
      state.bikkurapon.availablePlayCount = payload
    },
    setBikkuraponPlayedCount(state, payload) {
      state.bikkurapon.playedCount = payload
    },
    setBikkuraponWinningCount(state, payload) {
      state.bikkurapon.winningCount = payload
    },
    setSideMenuBikkuraponEnabled(state, payload) {
      state.sideMenuBikkurapon.gameEnabled = payload
    },
    setSideMenuBikkuraponLotteryAmount(state, payload) {
      state.sideMenuBikkurapon.lotteryAmount = payload
    },
    setSideMenuBikkuraponSideMenuAmount(state, payload) {
      state.sideMenuBikkurapon.sideMenuAmount = payload
    },
    setSideMenuBikkuraponPlayedCount(state, payload) {
      state.sideMenuBikkurapon.playedCount = payload
    },
    setSideMenuBikkuraponWinningCount(state, payload) {
      state.sideMenuBikkurapon.winningCount = payload
    },
    setPriceDisplayEnabled(state, payload) {
      state.priceDisplayEnabled = payload
    },
    setBikkuraponIconDisplayEnabled(state, payload) {
      state.bikkuraponIconDisplayEnabled = payload
    },
  },
}

export default user
